import { infiniteQueryOptions } from '@tanstack/react-query'
import { queryKeys } from '../keys'
import type {
  InfiniteData,
  UnusedSkipTokenInfiniteOptions,
} from '@tanstack/react-query'
import type { PaginationWithSearchQueryParam } from '@/types/shared'
import type { HTTPError } from 'ky'
import type { HttpErrorResponse } from '@/types/error'
import type { GetListAddOnsResponse } from '@/types/add-ons'
import { INITIAL_PER_PAGE } from '@/utils/constant'
import { addOnsService } from '@/services/add-ons'

export const getAddOnsQueryOptions = (
  params?: Partial<Pick<PaginationWithSearchQueryParam, 'search'>> & {
    booking_id: string
  },
  options?: Omit<
    UnusedSkipTokenInfiniteOptions<
      GetListAddOnsResponse,
      HTTPError<HttpErrorResponse>,
      InfiniteData<GetListAddOnsResponse, unknown>,
      ReturnType<typeof queryKeys.addOns.list>,
      number
    >,
    'queryKey' | 'queryFn' | 'initialPageParam' | 'getNextPageParam' | 'select'
  >,
) =>
  infiniteQueryOptions({
    initialPageParam: 1,
    queryKey: queryKeys.addOns.list(params),
    queryFn: ({ pageParam }) =>
      addOnsService.getList({
        searchParams: {
          ...params,
          page: pageParam,
          per_page: INITIAL_PER_PAGE,
        },
      }),
    getNextPageParam: (lastPage) => lastPage.meta.next_page,
    ...options,
  })
